/* eslint-disable react-native/no-inline-styles */
import React, { useRef } from "react";
import { View, Text, StyleSheet, Linking } from "react-native";
import { globalFontStyle, globalStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import { Network } from "../../../utils/network";
import { bottomsheet_top, withdraw_err } from "../../../utils/images";
import {Button} from '../../../components/core/Button';
import RupeeVal from "../../../commonComponents/RupeeVal";
import FastImage from "../../../common/FastImage";
import Width from "../../../assets/Width";
import { isMobile } from "../../../utils/commonMethods";
import { useNavigation } from "@react-navigation/native";
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import {globalConfigurableData, GlobalScreens} from "../../../utils/globalConstant";

const WithdrawInfo = ({ amountToWithdraw, withDrawConfirmBtnClick }) => {
  const navigation = useNavigation();
  const ref = useRef(null);
  const [tdsBreakUp, setTdsBreakUp] = React.useState({
    detailsArr1: [],
    detailsArr2: [],
  });
  const [err, setErr] = React.useState(false);

  React.useEffect(() => {
    getTdsBreakUp();
  }, []);

  const confirmButtonClick = () => {
    if (isMobile()) {
      navigation.pop();
    }
    withDrawConfirmBtnClick();
  };

  const getTdsBreakUp = async () => {
    const amount = {
      amount: amountToWithdraw,
    };

    const res = await Network.tdsBreakUp(amount);

    if (res?.data?.success !== false) {
      setTdsBreakUp(
        res?.data || {
          detailsArr1: [],
          detailsArr2: [],
        }
      );
      setErr(false);
    } else {
      setErr(true);
    }
  };

  function nav(link) {
    if (link) {
      Linking.openURL(link);
    }
  }

  return (
    <View style={styles.withdrawInfoBlk} ref={ref}>
      {/* <View style={{ alignItems: "center" }}>
        <FastImage
          style={{ width: 47, height: 5, paddingBottom: 35 }}
          source={bottomsheet_top()}
        />
      </View> */}

      {err ? (
        <View style={{ alignItems: "center" }}>
          <FastImage
            style={{ height: 90, width: 90, marginBottom: 20, marginTop: 10 }}
            source={withdraw_err()}
          />
          <FormTextLabel
              labelStyles={{
                ...globalFontStyle.appFontTitle,
                paddingBottom: 15,
                paddingTop: 2,
                color: globalConfigurableData.primaryTextColor1
              }}
            label={'Something Went Wrong'}
            />
          <FormTextLabel
              label={'There is some error while processing your request. Please try again'}
              labelStyles={{ ...globalFontStyle.appFontBody, color: globalConfigurableData.secondaryTextColor1 }}
          />
        </View>
      ) : (
        <View style={{ alignItems: "center" }}>
          {/* <RupeeVal
            rupeeVal={
              tdsBreakUp?.withdrawAmount ? tdsBreakUp?.withdrawAmount : "0"
            }
            customStyle={{
              ...globalFontStyle.appFontTitleHead,
              color: Colors.green,
            }}
          />
          <Text
            style={{
              ...globalFontStyle.appFontSubHeading,
              color: Colors.lightgrey,
              paddingBottom: 15,
              paddingTop: 2,
            }}
          >
            Withdrawal (After TDS & Bank Charges)
          </Text>
          <Text
            style={{
              ...globalFontStyle.appFontSmallText10,
              color: Colors.grey,
            }}
          >
            {tdsBreakUp?.govtRules}
          </Text> */}
        </View>
      )}
      {err ? (
        <View style={styles.withdrawStatusDetails}>
          <FormTextLabel
              labelStyles={{
                ...globalFontStyle.appFontSubText,
                color: GlobalScreens.Wallet.highlightColor,
              }}
              label={'If the error persists, please contact us via help@tradexapp.co'}
          />
        </View>
      ) : (
        <View>
          <View style={styles.withdrawInfoDetails}>
            <FormTextLabel
                labelStyles={{
                  ...globalFontStyle.appFontSubTextBold,
                  color: globalConfigurableData.primaryTextColor1,
                }}
                label={'Applicable for FY 23-24'}
            />
            <View
              style={{
                paddingBottom: 10,
                paddingTop: 20,
                borderBottomColor: GlobalScreens.AddMoney.borderColor,
                borderBottomWidth: 1,
                borderStyle: "dashed",
              }}
            >
              {tdsBreakUp?.detailsArr1?.map((item, i) => {
                return (
                  <View
                    key={i}
                    style={{
                      justifyContent: "space-between",
                      alignItems: "flex-end",
                      paddingTop: 10,
                      flexDirection: "row",
                    }}
                  >
                    <FormTextLabel
                        labelStyles={{
                          ...globalFontStyle.appFontSubText,
                          color: globalConfigurableData.primaryTextColor1,
                        }}
                        label={item?.text}
                    />
                    <RupeeVal
                      rupeeVal={item?.value}
                      customStyle={{
                        ...globalFontStyle.appFontSubText,
                        color: globalConfigurableData.primaryTextColor1,
                      }}
                    />
                  </View>
                );
              })}
            </View>
            <View style={{ paddingBottom: 10, paddingTop: 20 }}>
              {tdsBreakUp?.detailsArr2?.map((item, i) => {
                return (
                  <View
                    key={i}
                    style={{
                      justifyContent: "space-between",
                      alignItems: "flex-end",
                      paddingTop: 10,
                      flexDirection: "row",
                    }}
                  >
                    <FormTextLabel
                        labelStyles={{
                          ...globalFontStyle.appFontSubText,
                          color: globalConfigurableData.primaryTextColor1,
                        }}
                        label={item?.text}
                    />
                    <RupeeVal
                      rupeeVal={item?.value}
                      customStyle={
                        item?.text === "Amount Deposited in Your Bank "
                          ? {
                              ...globalFontStyle.appFontSubTextBold,
                              color: globalConfigurableData.primaryTextColor1,
                            }
                          : {
                              ...globalFontStyle.appFontSubText,
                              color: globalConfigurableData.primaryTextColor1,
                            }
                      }
                    />
                  </View>
                );
              })}
            </View>
          </View>
          <View style={styles.withdrawInfoQueryBox}>
            <Text>
            <FormTextLabel
                labelStyles={{
                  ...globalFontStyle.appFontSubTextBold,
                  color: globalConfigurableData.primaryTextColor1,
                  textAlign: "center",
                }}
                label={"How it’s calculated? "}
            />
            <FormTextLabel
                labelStyles={{
                  ...globalFontStyle.appFontSubTextBold,
                  color: globalConfigurableData.primaryTextColor1,
                  textAlign: "center",
                }}
                label={"Check this"}
            />
            </Text>
          </View>
        </View>
      )}
      <View
        style={[
          globalStyle.bottomAbsBtnBar,
          { width: ref?.current?.offsetWidth },
        ]}
      >
        <Button
          variant="primary"
          onPress={err ? getTdsBreakUp : confirmButtonClick}
          style={{ flex: 1 }}
          translate={true}
        >
          {err ? "Retry" : "Confirm Request"}
        </Button>
      </View>
    </View>
  );
};

export default WithdrawInfo;

const styles = StyleSheet.create({
  withdrawInfoBlk: {
    //paddingHorizontal: 16,
    paddingBottom: 16,
    paddingTop: 18,
    flex: 1,
  },

  withdrawInfoDetails: {
    //marginTop: 10,
    marginBottom: 35,
    paddingHorizontal: 18,
    paddingTop: 25,
    borderColor: "#C0C0C0",
    borderWidth: 0.75,
    borderRadius: 5,
  },

  withdrawInfoQueryBox: {
    borderTopColor: "#C0C0C0",
    borderTopWidth: 0.75,
    borderBottomWidth: 0.75,
    paddingHorizontal: 16,
    borderStyle: "dashed",
    paddingVertical: 10,
    marginHorizontal: -16,
  },

  withdrawStatusDetails: {
    padding: 20,
    marginHorizontal: -16,
    marginTop: 40,
    marginBottom: 70,
    backgroundColor: GlobalScreens.AddMoney.disclaimerBgColor,
    textAlign: "center",
  },
});
